"use strict";var _interopRequireDefault=require("@babel/runtime/helpers/interopRequireDefault");var _styledComponents=_interopRequireDefault(require("styled-components"));Object.defineProperty(exports,"__esModule",{value:!0}),exports.Tender=exports.SubHeading=void 0;const SubHeading=exports.SubHeading=_styledComponents.default.div` font-style: normal;
font-weight: 600;
font-size: 20px;
line-height: 24px;
/* identical to box height, or 120% */
font-feature-settings: "liga" off, "calt" off;
/* Common/Neutral/N800 BrownRegular */
color: #2a2928;
`,Tender=exports.Tender=_styledComponents.default.div`
display: inline-flex;
flex-wrap: wrap;
gap: 24px;
margin-top:16px
margin-top:16px;
max-width :750px;
`;